import React, { Component } from "react";
import { ControlLabel, Button, PageHeader, Grid, Row, Col, Modal } from "react-bootstrap";
import { invokeGetWorkoutAllExerciseMetrics, invokeSetAthleteExerciseMetrics } from "../../utils/AwsInvoke";
import { getMeasureTitle }          from "../../utils/Measure";
import { freeform_id }              from "../../utils/Constants";
import uniqueId                     from 'lodash/uniqueId';
import LoaderButton                 from "../../components/LoaderButton";
import YouTubeThumbnail             from "../../components/YouTubeThumbnail";
import YouTubePlayer                from "../../components/YouTubePlayer";
import PanelMeasureAddSubtract      from "../../components/PanelMeasureAddSubtract";
import "../../css/zeus.css";

// Capture data in global vals for the "Save All" button;
// Can't add in SetState otherwise there's an endless loop
// Below is a temp solution, replace shortly
var save_all_measure_1_vals;
var save_all_measure_2_vals;
var save_all_measure_id_vals;

export default class Zeus extends Component {
    constructor(props) {
        super(props);

        this.state = {
            day_id: `${this.props.match.params.id}`,
            isLoading: true,
            list: [],
            zeusModalShow: false
        };

    }

    async componentDidMount() {
        if (!this.props.isAuthenticated) {
            return;
        }

        try {
            console.log("Component mounted");
            this.renderExerciseSetList();
        } catch (e) {
            alert(e);
        }

        this.setState({ isLoading: false });
    }

    async renderExerciseSetList() {
        var day_id   = this.state.day_id;
        //var results  = await invokeGetWorkoutAllExerciseMetrics(day_id);

        /*if(results.status) {

            var list  = results.data.blocks;
            var names = results.data.names;
            var metric_data = results.data.metric_data;
            var free_form_notes = "";//results.data.exercise_details.notes; // for FreeForm exercises
            console.log("AWS Invoked!!!");

            this.setState({
                list:            list,
                names:           names,
                metric_data:   metric_data,
                free_form_notes: free_form_notes,
                athlete_metrics: "", //athlete_metrics,
                activeKey:       "0", //active_key
            })
        }*/
    }

    openZeusModal = (name, set_reps) => {
        console.log("name: " + name);
        this.setState({
            zeusModalShow: true,
            username: name,
            set_reps_a: set_reps[0],
            set_reps_b: set_reps[1],
        })
    }

    closeZeusModal = () => {
        this.setState({
            zeusModalShow: false
        })
    }

    saveSingleSetMetricData = (set_number, measure_a_value, new_val) => {
        this.setState({
            zeusModalShow: false
        })
    }

    createRow (ctr) {

        var tmp_ctr = 1;
        var tile_arr = [];
        var color_arr = ["e91e63",
                         "259b24",
                         "ff9800",
                         "e51c23",
                         "9c27b0",
                         "009688",
                         "03a9f4",
                         "607d8b",
                         "5677fc"]
        var name_arr = ["Hannah Deghan", "Jack Cooney", "Andrew Gibson", "Joseph Moreno", "Gabriel Medina", "Joe Humfeld", "Sebastian Zietz", "Carissa Moore", "Joel Parkinson"]
        var set_arr  = [[5,5],[3,8],[4,7],
                        [3,8],[3,6],[3,8],
                        [4,6],[4,7],[3,8]]
        var exercise_arr = ["Standing Keiser Cuff 3 Way Glute Reach With Dowel",
                            "Keiser Speed Bar Back Squat",
                            "Keiser Push Pull with Step and Rotation",
                            "Wide Base Cable Transverse Rotation with Rope",
                            "Staggered Stance Cookbar Cable Chop",
                            "Keiser Cable Resisted Lateral Step Up",
                            "Keiser Resisted Broad Jump Belt",
                            "Cable Resisted Alphabet at Keiser",
                            "Keiser Bike"]
        var percentmax_arr = ["80", "90", "75", "85","95","65","85","90","95"];
        for(var i = 0; i < 3; i++) {
            var card_ctr  = (ctr*3) + i;

            tile_arr.push(<Col key={tmp_ctr++} xs={4} md={4} className="padding-0-zeus">
                                <div className="zeusTile"
                                     onClick={this.openZeusModal.bind(this, name_arr[card_ctr], set_arr[card_ctr])}
                                >
                                    <div className="zeusUserName" style={{color: "#"+color_arr[card_ctr]}}> {name_arr[card_ctr]} </div>
                                    <div className="zeusSetCounter" onClick={this.openZeusModal}>Set {this.getRandomInt(8)}</div>
                                    <div className="zeusMetrics">
                                        { set_arr[card_ctr][0] }
                                        <span className="zeusX">x</span>
                                        { set_arr[card_ctr][1] }
                                    </div>
                                    <div>
                                        <span className="zeusSetsRepsLabel1">Weight: LBs</span>
                                        <span className="zeusSetsRepsLabel2">Reps</span>
                                    </div>
                                    <div className="zeusPercentofMax">% of max: {percentmax_arr[card_ctr]}</div>
                                <div className="zeusExerciseName">{exercise_arr[card_ctr]}</div>
                                </div>
                          </Col>)
        }

        return tile_arr;
    }

    getRandomInt(max) {
        return Math.floor(Math.random() * Math.floor(max)+1);
    }



    renderGrid() {
        var cards_arr = [];
        var card_ctr = 1; // temp counter
        for(var i = 0; i < 3; i++) {
            var card = <Row key={i} className="show-grid zeusGrid">
                            { this.createRow(i) }
                       </Row>
             cards_arr.push(card)
             //card_ctr = cards_arr.length;
             //console.log("cards_arr: "  + (card_ctr*i));
        }

        return cards_arr
    }

    handleGenericClick = event => {
      event.preventDefault();
      this.props.history.push(event.currentTarget.getAttribute("href"));
    }

    renderLander() {
        return (
            <div className="lander">
                <h1>TS</h1>
                <p></p>
            </div>
        );
    }

    renderList() {
        return (
            <div className="list">
                {!this.state.isLoading && this.renderGrid(this.state.list)}
            </div>
        );
    }

    changeMetricValue = () => {
        console.log("changeMetricValue!!!");
    }

    render() {
        return (
          <div className="HomeProgramWorkoutDetails">
              { this.props.isAuthenticated ? this.renderList() : this.renderLander() }
              { /* ------ Modal ------ */ }
              <Modal
                  show={this.state.zeusModalShow}
                  onClick={() => this.closeZeusModal}
                  dialogClassName="custom-modal"
            >
              <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-lg">
                  Exercise Metrics for <b>{this.state.username}</b>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body style={{backgroundColor: "#efefef"}}>
                <h4></h4>
                <div className="workoutDetailsAccordionPanel">
                    <PanelMeasureAddSubtract saveSingleSetMetricData = {this.saveSingleSetMetricData}
                                             panel_ctr  = { "1" }
                                             measure_id = { "measure_id" }
                                             measure_a_value = { this.state.set_reps_a }
                                             measure_b_value = { this.state.set_reps_b }
                                             measure_c_value = { 120 } /* % of max note to left of Save btn */
                                             measure_rest    = { 30 }
                                             psmv_id         = { "id" }
                                             measure_a_id    = { 10 } /* measure 1 is static: Set*/
                                             measure_b_id    = { 2 }
                                             measure_2_title = { "Sets" }
                                             measure_3_title = { "Reps" }
                                             changeMetricValue = { this.changeMetricValue } />
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button onClick={this.closeZeusModal}>Close</Button>
              </Modal.Footer>
            </Modal>
          </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/zeus/Zeus.js